var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 15,
    viewBox: "0 0 51 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8751 14.1466V5.51562L38.3404 7.97716L38.3352 14.1466H34.8751Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5091 14.1437L43.2647 10.75L48.3487 12.5676C47.8492 12.9749 47.299 13.3153 46.7119 13.5802C45.8825 13.9589 44.9815 14.1538 44.0702 14.1515L40.5091 14.1437Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6156 7.09642L48.0682 3.65338H43.0127L40.2441 2.52957e-05H44.0694C44.9799 -0.0025551 45.8802 0.192313 46.7085 0.571268C48.3831 1.32166 49.7152 2.67573 50.4406 4.36484C50.8118 5.21542 51.0024 6.1342 51 7.06267C51.0019 7.99443 50.8114 8.91652 50.4406 9.77088C50.1018 10.5738 49.6229 11.3098 49.0265 11.9442L45.6156 7.09642Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9052 0L27.8673 10.3862L24.7309 0H22.1695L18.769 10.3862L15.9823 0H0V2.59656H5.02958V14.1564H8.23069V2.59656H13.4338L16.8758 14.1564H20.2893L23.3686 4.85557L26.2771 14.1564H29.7139L34.2229 0H30.9052ZM34.8756 0V3.66375H38.1699V0H34.8756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwid);
export default __webpack_public_path__ + "static/media/twid.759fa2d7e9bac7dc7daa00e3296b5d5c.svg";
export { ForwardRef as ReactComponent };